import { render } from "./sectionHeader.vue?vue&type=template&id=00a30a46"
import script from "./sectionHeader.vue?vue&type=script&lang=js"
export * from "./sectionHeader.vue?vue&type=script&lang=js"

import "./sectionHeader.vue?vue&type=style&index=0&id=00a30a46&lang=scss"

import exportComponent from "/Users/jeromebart/sites/cdm-quiz/cite-des-metiers/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__